import { render, staticRenderFns } from "./wlTitle.vue?vue&type=template&id=4fa8aadd&scoped=true"
import script from "./wlTitle.vue?vue&type=script&lang=js"
export * from "./wlTitle.vue?vue&type=script&lang=js"
import style0 from "./wlTitle.vue?vue&type=style&index=0&id=4fa8aadd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8aadd",
  null
  
)

export default component.exports